import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE_URL = 'https://jci-futures-observatory.lovable.app';

const routeNames: Record<string, string> = {
  '/dashboard': 'Dashboard',
  '/mental-health-dimension': 'Mental Health Dimension',
  '/regional-analysis': 'Regional Analysis',
  '/member-insights': 'Member Insights',
  '/programs-events': 'Programs & Events',
  '/technology-future': 'Technology & Future',
  '/impact-metrics': 'Impact & Metrics',
  '/vision-2040': 'Vision 2040',
  '/settings': 'Settings',
};

export function BreadcrumbSchema() {
  const location = useLocation();
  
  useEffect(() => {
    // Remove existing breadcrumb schema
    const existingScript = document.querySelector('script[data-schema="breadcrumb"]');
    if (existingScript) existingScript.remove();
    
    const currentPath = location.pathname;
    
    // Don't add schema for home/dashboard
    if (currentPath === '/' || currentPath === '/dashboard') {
      return;
    }
    
    const pageName = routeNames[currentPath] || currentPath.replace('/', '').replace(/-/g, ' ');
    
    const breadcrumbSchema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": `${BASE_URL}/dashboard`
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": pageName,
          "item": `${BASE_URL}${currentPath}`
        }
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-schema', 'breadcrumb');
    script.textContent = JSON.stringify(breadcrumbSchema);
    document.head.appendChild(script);
    
    return () => {
      const script = document.querySelector('script[data-schema="breadcrumb"]');
      if (script) script.remove();
    };
  }, [location.pathname]);

  return null;
}
